import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    situation: 'Psicólogo por estrés y ansiedad (2x mes)',
    cost: '$480.000 - $960.000 por año'
  }, {
    situation: 'Kinesiología por dolores tensionales',
    cost: '$180.000 - $360.000 por año'
  }, {
    situation: 'Pastillas para dormir y suplementos',
    cost: '$120.000 - $240.000 por año'
  }, {
    situation: 'Días de baja productividad por fatiga',
    cost: 'Sin precio. Costo real enorme.'
  }, {
    situation: 'Conflictos relacionales por irritabilidad',
    cost: 'Sin precio. Costo real enorme.'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-54">
      <FadeIn data-id="element-55">
        <div className="text-center mb-6 md:mb-14" data-id="element-56">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#ef4444]/10 mb-3 md:mb-6 border border-[#ef4444]/20" data-id="element-57">
            <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-58">
              ⚖️
            </span>
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#1f1b16] mb-2 md:mb-4 px-2" data-id="element-59">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <p className="text-sm md:text-xl text-[#6b6358] font-bold" data-id="element-60">
            El precio real de seguir como hasta ahora.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8" data-id="element-61">
        {costs.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-62">
            <motion.div whileHover={{
          scale: 1.02
        }} className="bg-[#faf7f2] border border-[#e7dfce] hover:border-[#ef4444]/50 rounded-2xl p-4 md:p-6 flex flex-col justify-between h-full group relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-63">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#ef4444]/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-[#ef4444]/10 transition-colors" data-id="element-64"></div>

              <p className="text-sm md:text-base text-[#1f1b16] font-bold mb-3 md:mb-4 relative z-10" data-id="element-65">
                {item.situation}
              </p>

              <div className="flex items-center gap-2 md:gap-3 bg-[#ef4444]/5 p-3 md:p-4 rounded-xl border border-[#ef4444]/10 relative z-10" data-id="element-66">
                <AlertOctagon className="text-[#ef4444] shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-67" />
                <span className="font-black text-[#ef4444] text-sm md:text-lg leading-tight" data-id="element-68">
                  {item.cost}
                </span>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-69">
        <div className="bg-[#1f1b16] rounded-2xl p-6 md:p-8 border border-[#7c3aed]/30 shadow-lg max-w-3xl mx-auto text-center relative overflow-hidden" data-id="element-70">
          <div className="absolute inset-0 bg-[#7c3aed]/5 blur-3xl rounded-full" data-id="element-71"></div>
          <p className="text-[#ef4444] font-black text-lg md:text-2xl mb-4 relative z-10" data-id="element-72">
            TOTAL ANUAL SIN SISTEMA: $780.000 - $1.560.000+
          </p>
          <div className="w-full h-px bg-[#e7dfce]/20 my-4 relative z-10" data-id="element-73"></div>
          <p className="text-[#faf7f2] font-bold text-base md:text-xl mb-4 relative z-10" data-id="element-74">
            Con el Botiquín Vibracional Pro:
          </p>
          <ul className="text-[#a78bfa] text-sm md:text-lg font-medium space-y-2 mb-6 relative z-10" data-id="element-75">
            <li data-id="element-76">
              ✅ Herramientas de regulación en 5 min. Ahorro: $480.000-$960.000
            </li>
            <li data-id="element-77">✅ Protocolos físicos desde casa. Ahorro: $180.000-$360.000</li>
            <li data-id="element-78">✅ Sueño reparador sin pastillas. Ahorro: $120.000-$240.000</li>
            <li data-id="element-79">✅ Productividad real recuperada. Valor: incalculable</li>
            <li data-id="element-80">✅ Convivencia más armónica. Valor: incalculable</li>
          </ul>
          <p className="text-[#7c3aed] font-black text-xl md:text-3xl drop-shadow-[0_0_10px_rgba(124,58,237,0.3)] relative z-10" data-id="element-81">
            RETORNO POTENCIAL PRIMER AÑO: 15x - 45x
          </p>
        </div>
      </FadeIn>
    </section>;
}